import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobService } from 'src/app/core/services/job.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';

// Native port of the legacy workFlowStepWarning/workflowStepWarningModal pair
// (src/app/public/app/partials/missioncontrol/company/workFlowStepWarning,
// workflowStepWarningModal). workflowStepWarningModal
// (workflow-step-warning-modal.component.js) was the $uibModal wrapper opened
// by company-page.component.js's showCandidatesAvailableOnStepWarning
// (component: 'workflowStepWarningModal'), and it embedded
// workFlowStepWarning (work-flow-step-warning.component.js,
// <work-flow-step-warning> element) as its body content - confirmed by
// workflow-step-warning-modal.html:16-23 nesting <work-flow-step-warning>,
// and by workFlowStepWarning not being opened directly as a modal/state
// anywhere else in the app. A native BsModalService modal doesn't need that
// wrapper/content-component split, so both are merged into this one
// component, same pattern as CompanyPageChangeCompanyStateModalComponent.
@Component({
  selector: 'app-company-page-workflow-step-warning-modal',
  templateUrl: './company-page-workflow-step-warning-modal.component.html',
  styleUrls: ['./company-page-workflow-step-warning-modal.component.css']
})
export class CompanyPageWorkflowStepWarningModalComponent implements OnInit {

  public onClose: Subject<any>;

  modalData: any = {};

  context: string;
  companyId: any;
  clientOrBuId: any;
  message: string;
  stepName: string;

  isDetailsFetched = false;
  showDetailsFlag = false;

  requisitions: any[] = [];
  clientOrBus: any[] = [];

  private stepDetails: any;

  callbackObject: any = { callbackType: 'cancel', entity: {} };

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService,
    private companyService: CompanyService,
    private jobService: JobService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.context = this.modalData.context;
    this.companyId = this.modalData.companyId;
    this.clientOrBuId = this.modalData.clientOrBuId;
    this.message = this.modalData.message;
    this.stepName = this.modalData.stepName;

    if (this.stepName && this.stepName.includes('Verification')) {
      this.stepName = 'Verification';
    }
    this.stepDetails = {
      companyId: this.companyId,
      workflowStep: this.stepName
    };
    if (this.context === 'clientOrBu') {
      this.stepDetails.clientOrBuId = this.clientOrBuId;
    }
    this._getDetails();
  }

  _getDetails() {
    if (this.context === 'clientOrBu') {
      this._getRequisitions();
    } else {
      this._getClientsOrBus();
    }
  }

  _getRequisitions() {
    this.jobService.getRequisitionsInWorkFlowStep(this.stepDetails, (data: any) => {
      this.isDetailsFetched = true;
      this.requisitions = data;
      this._setCountInMessage(this.requisitions.length);
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _getClientsOrBus() {
    this.companyService.getWorkFlowStepClientOrBuDetails(this.stepDetails, (data: any) => {
      this.isDetailsFetched = true;
      this.clientOrBus = data;
      this._setCountInMessage(this.clientOrBus.length);
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _setCountInMessage(count: number) {
    const wordsInMessage = this.message.split(' ');
    wordsInMessage[0] = count.toString();
    this.message = wordsInMessage.join(' ');
  }

  showDetails() {
    this.showDetailsFlag = true;
  }

  closeModal() {
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }
}
